import Settings from 'src/Settings';
import RedesignDescriptor from './button-redesign';
import RefiveDescriptor from './button-refive';
import CanteenDescriptor from './button-canteen';
import AramarkDescriptor from './button-aramark';
import CompanyKitchenDescriptor from './button-companykitchen';
import {ButtonType} from 'src/components/elements/RoundedButton';
import {BuildTypeEnum} from '../../../constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getButtonDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}

export interface RoundedBtnDescriberProps {
  disabled?: boolean;
  color?: string;
  buttonType: ButtonType;
  textColor?: string;
}
